import { isAxiosError } from 'axios';
import { Result, err, ok } from 'neverthrow';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore utils is in the parent dir
import axios from '@utils/axios';

import { ApiError } from 'types/api/ApiError';
import captureException from 'utils/captureException';

export type ToggleQQAgentDisabledResponse = {
  agentId: number;
  disabled: boolean;
};

export async function toggleQQAgentDisabled(
  agentId: number,
  disabled: boolean
): Promise<Result<ToggleQQAgentDisabledResponse, ApiError>> {
  try {
    const response = await axios.patch<ToggleQQAgentDisabledResponse>(
      `/agent/quick-quote/agents/${agentId}/toggle-disabled`,
      { disabled }
    );

    return ok(response.data);
  } catch (error) {
    captureException(error, { functionName: 'toggleQQAgentDisabled' });

    if (!isAxiosError(error)) {
      return err({ message: 'Failed to update agent status.' });
    }

    if (error.response?.status === 401) {
      throw error;
    }

    return err({
      message:
        error.response?.data?.message || 'Failed to update agent status.',
    });
  }
}
